import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncPostLogin({ payload }) {
    try {
        let response = yield call(API.postLogin, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_LOGIN,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostGoogleLogin({ payload }) {
    try {
        let responseLogin = yield call(API.postGoogleLogin, payload);
        if (responseLogin)
            yield put({
                type: actionTypes.SUCCESS_POST_GOOGLE_LOGIN,
                response: responseLogin,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostLogout({ payload }) {
    try {
        let response = yield call(API.postLogout, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_LOGOUT,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostRegister({ payload }) {
    try {
        let response = yield call(API.postRegister, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_REGISTER,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetRetrieveUser({ payload }) {
    try {
        let response = yield call(API.getRetrieveUser, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_RETRIEVE_USER,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostConfirmUser({ payload }) {
    try {
        let response = yield call(API.postConfirmUser, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_CONFIRM_USER,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetValidateUsername({ payload }) {
    try {
        let response = yield call(API.getValidateUsername, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_VALIDATE_USERNAME,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostPasswordRecover({ payload }) {
    try {
        let response = yield call(API.postPasswordRecover, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_PASSWORD_RECOVER,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPutResetPassword({ payload }) {
    try {
        let response = yield call(API.putResetPassword, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_PUT_RESET_PASSWORD,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncPostUpdateProfessional({ payload }) {
    try {
        let response = yield call(API.postUpdateProfessional, payload);
        if (!response?.data?.error){
            yield put({
                type: actionTypes.GET_RETRIEVE_USER,
                payload,
            })
        }else{
            yield put({
                type: actionTypes.ERROR_LOGIN,
                response: true,
                message: '',
            });
        }
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_LOGIN,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetAllUsers({ payload }) {
    try {
        let response = yield call(API.getAllUsers, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_ALL_USERS,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_USERS,
            response: error,
            message: error.message,
        });
    }
}

function* asyncGetUserDetail({ payload }) {
    try {
        let response = yield call(API.getUserDetail, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_GET_DETAIL_USER,
                response,
            });
    } catch (error) {
        yield put({
            type: actionTypes.ERROR_USERS,
            response: error,
            message: error.message,
        });
    }
}

export default function* userSaga() {
    yield takeLatest(actionTypes.POST_LOGIN, asyncPostLogin);
    yield takeLatest(actionTypes.POST_GOOGLE_LOGIN, asyncPostGoogleLogin);
    yield takeLatest(actionTypes.POST_LOGOUT, asyncPostLogout);
    yield takeLatest(actionTypes.POST_REGISTER, asyncPostRegister);
    yield takeLatest(actionTypes.GET_RETRIEVE_USER, asyncGetRetrieveUser);
    yield takeLatest(actionTypes.POST_CONFIRM_USER, asyncPostConfirmUser);
    yield takeLatest(actionTypes.GET_VALIDATE_USERNAME, asyncGetValidateUsername);
    yield takeLatest(actionTypes.POST_PASSWORD_RECOVER, asyncPostPasswordRecover);
    yield takeLatest(actionTypes.PUT_RESET_PASSWORD, asyncPutResetPassword);
    yield takeLatest(actionTypes.POST_UPDATE_PROFESSIONAL, asyncPostUpdateProfessional);
    yield takeLatest(actionTypes.GET_ALL_USERS, asyncGetAllUsers);
    yield takeLatest(actionTypes.GET_DETAIL_USER, asyncGetUserDetail);
}